import Select, { components } from 'react-select';
import { MdGroupAdd } from 'react-icons/md';
const DropdownIndicator = (props) => {
    let val = 25
    return (
        <components.DropdownIndicator {...props}>
            <MdGroupAdd size={val} />
        </components.DropdownIndicator>
    );
};
export default DropdownIndicator;